import { useMutation } from '@apollo/client';

import { EntityPagesArticleModuleFeatureArticleDocument } from '../graphql/mutations/entity-pages-article-module-feature-article.gql-types';

export const useFeatureArticleMutation = () => {
  return useMutation(EntityPagesArticleModuleFeatureArticleDocument);
};
